export const API_URL = {
  // Vendor UAA Service

  logout: "/api/vendor-uaa/api/v1/logout",
  forgot_Password_url: "/api/vendor-uaa/api/v1/forgot-credentials-mail",
  changeForgotPassword: "/api/vendor-uaa/api/v1/forgot-credentials",
  generateCaptchaForgorPassword: "/api/vendor-uaa/api/v1/generate-captcha",

  // Vendor Registration Service
  verifyOtp: "/api/vendor-user-registration/api/v1/verify-email",
  submitRegistration: "/api/vendor-user-registration/api/v1/submit",
  requestOtp: "/api/vendor-user-registration/api/v1/request-otp",
  saveUserDetails: "/api/vendor-user-registration/api/v1/save",
  verifyVendor: "/api/vendor-user-registration/api/v1/verify-vendor",
  generateCaptchUrl: "/api/vendor-user-registration/api/v1/generate-captcha",
  generateNewCaptchUrl: "/api/vendor-user-registration/api/v1/refresh-captcha",

  // Vendor Profile Service
  getVendorFcMaster: "/api/vendor-profile/api/v1/get-fc-masters",
  getVendorDetails: "/api/vendor-profile/api/v1/get-vendor-details",
  editVendor: "/api/vendor-profile/api/v1/edit-vendor",
  getVendorFc: "/api/vendor-profile/api/v1/get-vendor-fc",
  addVendorFcMapping: "/api/vendor-profile/api/v1/add-vendor-fc-mapping",
  toggleVendorFcMapping: "/api/vendor-profile/api/v1/toggle-vendor-fc-mapping",

  // Vendor Appointment Listing Service
  appointmentListing: "/api/vendor-appointment/api/v1/view-appointments",
  bulkFileList: "/api/vendor-bulk-appointment/api/v1/get-file-list",
  vendorBulkAppoitmentUrl:
    "/api/vendor-bulk-appointment/api/v1/book-appointments",
  getBulkAppointments:
    "/api/vendor-bulk-appointment/api/v1/get-bulk-appointments",

  // Appointment Booking Service
  materialTypeListUrl: "/api/appointment-booking/api/v1/get-material-types",
  vehicalTypeListUrl: "/api/appointment-booking/api/v1/get-vehicle-types",
  appointmentCount: "/api/appointment-booking/api/v1/appointment-count",
  vendorAppoitmentCancelUrl:
    "/api/appointment-booking/api/v1/cancel-appointment",
  vendorAppoitmentUpdateUrl: "/api/appointment-booking/api/v1/edit-appointment",
  reserveTimeSlot: "/api/appointment-booking/api/v1/reserve-slot",
  fetchTimeSlot: "/api/appointment-booking/api/v1/book-slot",
  fetchTimeSlotCentral: "/api/appointment-booking/api/v1/book-slot",
  validateSlot: "/api/appointment-booking/api/v1/validate-slot",
  validateVendorPo: `/api/appointment-booking/api/v1/validate-po`,
  noOfVehicleCount: "/api/appointment-booking/api/v1/get-max-no-of-vehicle",
  vendorAppoitmentSubmitUrl: "/api/appointment-booking/api/v1/book-appointment",
  searchAppointmentbByValueUrl:
    "/api/vendor-appointment/api/v1/search-appointment",
  verifyFC: "/api/vendor-appointment/api/v1/verify-fc",

  // Vendor Query Service
  downloadQueryDocument: "/api/vendor-query/api/v1/download-document",
  queryAttachmentList: "/api/vendor-query/api/v1/list-document",
  listQueryTypeDetails: "/api/vendor-query/api/v1/list-query-type-details",
  createNewQuery: "/api/vendor-query/api/v1/save-query-details",
  searchVendorQuery: "/api/vendor-query/api/v1/search-query",
  queryList: "/api/vendor-query/api/v1/list-query-details",
  queryThreadList: "/api/vendor-query/api/v1/list-query-thread-details",
  saveQueryThreadDetails: "/api/vendor-query/api/v1/save-query-thread-details",

  //Middleware
  validateData: "/api/appointment-booking/api/v1/order/data/validate",

  configMaster : "/central-mdm/api/v1/central/master/config",
  appointmentConfigURL: "/api/vendor-appointment/api/v1/fetch-appointment-configs"
};
